import { VehicleIdentificationDto } from "@tm/utils"
import { SearchFilterTMA } from "../articleItem"
import { ECounterType } from "./eCountType"
import { TmaEModule } from "./emodule"

export { TmaEModule }
export { ECounterType }

export type UserInteractionLog = {
    eventId: string // not used in backend
    id?: string

    origin: TmaEModule

    stepNumber?: number
    fromPageNumber?: number
    fromPositionNumber?: number

    vehicleSearchTerm?: string // not used in backend
    vehicleDataSourceId?: number // not used in backend

    foundByQuery?: string
    foundByQuerySourceId?: EFoundBySearchTermSourceId

    vehicleIdentification?: VehicleIdentificationDto
    searchFilters?: SearchFilterTMA[]

    excludeWorkTaskVehicle?: boolean
}

export type VehicleSelectionLog = {
    origin: TmaEModule
    selectedConstructionYearFilter?: number

    /**
     * VEHICLE_IDENTIFICATIONTYPEID
     * The value of the id can be taken from the MDM list for available types of vehicle identification
     * (see Visual Studio TeamExplorer - Project MDM - Documents - Development - Kundenverwaltung.xlsx - System-AddOn).
     * IdentificationTypeId defines type of the identification process like identification by vehicle tree search,
     * plateId, motor code, TecDocTypeId, Gerausiv webservice, etc.
     */
    dataSourceId: number

    /**
     * VEHICLE_IDENTIFICATIONKEY
     * Search keyword. In case of a plateId search the plateId.
     */
    searchTerm: string
}

export enum EFoundBySearchTermSourceId {
    //     Defines the source functionality that is responsible for a search term. It is
    //     used as additional information for a basket part to determine which search was
    //     used to find the part. The related search term should be named: FoundBySearchTerm
    //     or FoundByQuery. It's used in e.g. Basket, Voucher, ErpConnect and Next logging
    //     for Tma.
    Undefined = 0,
    ArticleDirectSearch = 1,
    UniversalArticleSearch = 2,
    VehicleProductGroupSearch = 3,
}
